// The patient's waitlist requests, loaded once for the page.
//
// Lifted out of the section component because the TAB needs the count and the
// panel needs the rows, and two components fetching the same list is two
// answers to "how many am I waiting on" that can disagree on screen.
//
// `reload` is returned rather than a refresh interval: the list only changes
// when this patient edits it or the clinic fills something, and a poll would
// ask a question nobody asked.

import {useCallback, useEffect, useState} from "react";
import {listMyWaitlistRequests} from "./api";

export default function useMyWaitlistRequests(dashState) {
  const [entries, setEntries] = useState([]);
  const [allowEdits, setAllowEdits] = useState({});
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  const reload = useCallback(async () => {
    try {
      const result = await listMyWaitlistRequests(dashState);
      setEntries(result.entries);
      setAllowEdits(result.allowEdits);
      setFailed(false);
    } catch (error) {
      // FAILURE IS NOT EMPTINESS. An empty list means "you are on no list",
      // which is the one wrong answer this screen can give, so the caller is
      // told the read failed and says so instead of drawing nothing.
      setFailed(true);
    } finally {
      setLoading(false);
    }
  }, [dashState]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {entries, allowEdits, loading, failed, reload};
}
